/* uwelle® · Scripts del sitio (se enlaza con `defer` desde snippets/uwelle-marca-tema.liquid)
   24 sep 2026 · Antes eran tres <script> dentro de cada página. Como archivo,
   el navegador lo guarda y no lo vuelve a bajar en la página siguiente.
   `defer` los ejecuta cuando el HTML ya está leído, antes de DOMContentLoaded:
   todo lo que tocan (cabecera, pie, carrito) ya existe.
   1 · Carrito vivo (antes en uwelle-marca-tema)
   2 · Menú, cajón y limpieza de la cabecera del tema (antes en uwelle-encabezado;
       la medida de la barra fija sigue en línea)
   3 · Insignia de Google Customer Reviews (antes en uwelle-google-reviews) */

/* ===== 1 · Carrito vivo ===== */
(function () {
    var ESPERA = 6000;
    var cierre = null;

    function plural(n) {
      return n + (n === 1 ? ' producto' : ' productos');
    }

    function pintar(n) {
      document.querySelectorAll('.u-nav__util a.u-pill[href="/cart"]').forEach(function (a) {
        var nodo = null;
        for (var i = a.childNodes.length - 1; i >= 0; i--) {
          var hijo = a.childNodes[i];
          if (hijo.nodeType === 3 && hijo.textContent.trim() !== '') {
            nodo = hijo;
            break;
          }
        }
        if (nodo) {
          nodo.textContent = String(n);
        } else {
          a.appendChild(document.createTextNode(String(n)));
        }
        a.setAttribute('aria-label', 'Carrito, ' + plural(n));
      });
    }

    function ocultar() {
      var caja = document.getElementById('uw-aviso-carrito');
      if (caja) caja.classList.remove('is-visible');
      clearTimeout(cierre);
    }

    function avisar(n) {
      if (/^\/cart/.test(location.pathname)) return;
      var caja = document.getElementById('uw-aviso-carrito');
      if (!caja) {
        caja = document.createElement('div');
        caja.id = 'uw-aviso-carrito';
        caja.className = 'uw-aviso-carrito';
        caja.setAttribute('role', 'status');
        caja.setAttribute('aria-live', 'polite');
        caja.innerHTML =
          '<button type="button" class="uw-aviso-carrito__x" aria-label="Cerrar aviso">&times;</button>' +
          '<p class="uw-aviso-carrito__t">Agregado a tu carrito</p>' +
          '<p class="uw-aviso-carrito__n"></p>' +
          '<a class="uw-aviso-carrito__btn" href="/cart">Ver carrito</a>';
        document.body.appendChild(caja);
        caja.querySelector('.uw-aviso-carrito__x').addEventListener('click', ocultar);
        caja.addEventListener('mouseenter', function () { clearTimeout(cierre); });
        caja.addEventListener('mouseleave', function () { cierre = setTimeout(ocultar, ESPERA); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') ocultar();
        });
      }
      caja.querySelector('.uw-aviso-carrito__n').textContent = plural(n) + ' en tu carrito';
      caja.classList.add('is-visible');
      clearTimeout(cierre);
      cierre = setTimeout(ocultar, ESPERA);
    }

    function refrescar(conAviso) {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          pintar(c.item_count);
          if (conAviso) avisar(c.item_count);
        })
        .catch(function () {});
    }

    document.addEventListener('cart:update', function (e) {
      var d = (e && e.detail) || {};
      var datos = d.data || {};
      var alta = datos.source === 'product-form-component' && !datos.didError;
      var carrito = d.resource || {};
      if (typeof carrito.item_count === 'number') {
        pintar(carrito.item_count);
        if (alta) avisar(carrito.item_count);
        return;
      }
      refrescar(alta);
    });

    /* Al volver con el botón «atrás», el navegador puede mostrar la página
       guardada con la cifra vieja: se vuelve a pedir. */
    addEventListener('pageshow', function (e) {
      if (e.persisted) refrescar(false);
    });
  })();

/* ===== 2 · Menú y cajón de la cabecera ===== */
(function(){
  'use strict';
  if(!document.querySelector('.uw-encabezado .uwh__fijo')) return;
/* --- Retirar la cabecera y el pie del tema ------------------------------
   Si el tema sigue montando los suyos, la pagina acaba con dos cabeceras
   superpuestas —el logotipo de una debajo de la otra— y dos pies, uno de
   ellos verde, que no pertenece a esta identidad. Lo correcto es quitarlos en
   layout/theme.liquid, pero esto lo resuelve aunque ese paso no se haya
   hecho. Para desactivarlo, anade la clase `uw-conserva-tema` al body. */
function limpiarTema(){
  if(document.body.classList.contains('uw-conserva-tema')) return;
  /* Solo se retira lo del tema si esta cabecera esta presente. Sin esta
     comprobacion, una pagina que no lleve la seccion se quedaba sin ninguna
     cabecera, y con ella desaparecia el logotipo. */
  if(!document.querySelector('.uwh')) return;
  var mios = ['.uw-encabezado','.uw-portada','.uw-pie','.uw-landing','.uw-ficha'];
  var esMio = function(el){ return mios.some(function(s){ return el.closest(s); }); };
  var tieneMio = function(el){ return mios.some(function(s){ return el.querySelector(s); }); };
  /* Muchos temas no usan <footer>: envuelven el pie en un <div>. Se buscan
     tambien las secciones de Shopify cuyo identificador o clase hable de
     cabecera, pie, anuncio o boletin, y se comprueba que no contengan nada
     nuestro antes de ocultarlas. */
  var patron = /(header|footer|announcement|newsletter|boletin|pie|cabecera)/i;
  var candidatos = new Set();
  /* Un <header> o <footer> dentro de una seccion de la plantilla es la
     cabecera de un bloque de contenido —la ficha usa uno en cada banda—, no
     la del tema, que se monta en su grupo de secciones, fuera de la
     plantilla. Sin esta guarda se ocultaba la seccion de contenido entera. */
  document.querySelectorAll('header, footer').forEach(function(el){
    if (el.closest('[id^="shopify-section-template--"]')) return;
    candidatos.add(el);
  });
  document.querySelectorAll('[id^="shopify-section"]').forEach(function(el){
    if (patron.test(el.id)) candidatos.add(el);
  });
  document.querySelectorAll('body > div, body > section').forEach(function(el){
    var marca = (el.id || '') + ' ' + (el.className || '');
    if (patron.test(marca)) candidatos.add(el);
  });
  candidatos.forEach(function(el){
    if(esMio(el) || tieneMio(el)) return;
    var caja = el.closest('[id^="shopify-section"]') || el;
    if(esMio(caja) || tieneMio(caja)) return;
    caja.setAttribute('hidden','');
    caja.style.setProperty('display','none','important');
  });
}
/* Se ejecuta dos veces: ahora, para la cabecera del tema —que va antes en el
   documento—, y al terminar de cargar, para el pie, que va despues y todavia
   no existe cuando este script se lee. */
limpiarTema();
if(document.readyState==='loading') addEventListener('DOMContentLoaded',limpiarTema);
else limpiarTema();

  /* ---------- menú ---------- */
  var items=[].slice.call(document.querySelectorAll('.u-nav__item[data-mega]'));
  var movil=matchMedia('(max-width:1180px)');
  function cerrar(x){items.forEach(function(it){if(it!==x){it.classList.remove('u-abierto');var b=it.querySelector('.u-nav__btn');if(b)b.setAttribute('aria-expanded','false');}});}
  /* El panel se despliega cuatro pixeles por debajo del boton, y esos cuatro
     pixeles no pertenecen a ningun elemento del menu: `elementFromPoint` en
     mitad del hueco devuelve la barra, no el item. Todo puntero real los cruza
     al bajar hacia el panel, y el `mouseleave` del item se disparaba antes de
     que el puntero llegara al panel: el megamenu se cerraba en el camino.
     Se nota mas cuanto mas lejos del boton este el renglon al que se va.

     El cierre espera una gracia de 160 ms. Cualquier reentrada —el propio
     panel es descendiente del item, asi que entrar en el vuelve a disparar su
     `mouseenter`— la cancela antes de que se cumpla, y la clase nunca llega a
     retirarse: no hay parpadeo. Al salir de verdad, 160 ms no se perciben. */
  var GRACIA=160, cierrePendiente=null;
  function cancelarCierre(){ if(cierrePendiente){ clearTimeout(cierrePendiente); cierrePendiente=null; } }
  function abrirItem(it,btn){ cancelarCierre(); cerrar(it); it.classList.add('u-abierto'); btn.setAttribute('aria-expanded','true'); }
  function cerrarConGracia(it,btn){
    cancelarCierre();
    cierrePendiente=setTimeout(function(){
      it.classList.remove('u-abierto'); btn.setAttribute('aria-expanded','false'); cierrePendiente=null;
    },GRACIA);
  }
  items.forEach(function(it){
    var btn=it.querySelector('.u-nav__btn');
    btn.addEventListener('click',function(e){e.preventDefault();
      var abierto=it.classList.contains('u-abierto');cancelarCierre();cerrar(it);
      it.classList.toggle('u-abierto',!abierto);btn.setAttribute('aria-expanded',String(!abierto));});
    it.addEventListener('mouseenter',function(){if(!movil.matches) abrirItem(it,btn);});
    it.addEventListener('mouseleave',function(){if(!movil.matches) cerrarConGracia(it,btn);});
  });
  document.addEventListener('click',function(e){if(!e.target.closest('.u-nav')){cancelarCierre();cerrar(null);}});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){cancelarCierre();cerrar(null);}});

  var burger=document.getElementById('uw-burger'),nav=document.getElementById('uw-nav'),
      velo=document.getElementById('uw-velo'),navCerrar=document.getElementById('uw-nav-cerrar');
  function cajon(abrir){
    nav.classList.toggle('u-cajon',abrir);
    document.body.classList.toggle('u-nav-abierto',abrir);
    burger.setAttribute('aria-expanded',String(abrir));
    if(abrir){ nav.scrollTop=0; navCerrar.focus({preventScroll:true}); } else { burger.focus({preventScroll:true}); }
  }
  burger.addEventListener('click',function(e){e.stopPropagation();cajon(!nav.classList.contains('u-cajon'));});
  navCerrar.addEventListener('click',function(){cajon(false);});
  velo.addEventListener('click',function(){cajon(false);});
  nav.addEventListener('click',function(e){ if(e.target.closest('a')) cajon(false); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&nav.classList.contains('u-cajon')) cajon(false); });
  matchMedia('(min-width:1181px)').addEventListener('change',function(m){ if(m.matches) cajon(false); });

})();

/* ===== 3 · Google Customer Reviews ===== */
(function () {
    var MERCHANT_ID = 5842996684;
    var API = 'https://apis.google.com/js/platform.js?onload=uwRenderGcrBadge';
    var pedida = false;

    function colocarContenedor() {
      var existente = document.getElementById('uw-gcr-badge');
      if (existente) return existente;

      var barra = document.querySelector('.uwf__bar') || document.querySelector('footer');
      if (!barra) return null;

      var c = document.createElement('div');
      c.id = 'uw-gcr-badge';
      c.className = 'uw-gcr';
      barra.appendChild(c);
      return c;
    }

    window.uwRenderGcrBadge = function () {
      if (!window.gapi) return;

      var dibujar = function (contenedor) {
        window.gapi.load('ratingbadge', function () {
          window.gapi.ratingbadge.render(contenedor, {
            merchant_id: MERCHANT_ID,
            position: 'INLINE'
          });
        });
      };

      var c = colocarContenedor();
      if (c) { dibujar(c); return; }

      // El pie aún no existe: se espera a que aparezca, con tope de 10 s.
      var obs = new MutationObserver(function () {
        var tardio = colocarContenedor();
        if (tardio) { obs.disconnect(); dibujar(tardio); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 10000);
    };

    function pedirApi() {
      if (pedida) return;
      pedida = true;
      var s = document.createElement('script');
      s.src = API;
      s.async = true;
      document.head.appendChild(s);
    }

    function vigilarPie() {
      var pie = document.querySelector('.uwf__bar') || document.querySelector('.uw-pie');
      if (pie && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entradas) {
          if (entradas.some(function (e) { return e.isIntersecting; })) {
            io.disconnect();
            pedirApi();
          }
        }, { rootMargin: '600px 0px' });
        io.observe(pie);
        return;
      }
      var tarde = function () { setTimeout(pedirApi, 5000); };
      if (document.readyState === 'complete') tarde();
      else window.addEventListener('load', tarde);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilarPie);
    else vigilarPie();
  })();